import { useTheme } from '@emotion/react';
import { Box, Button, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ControlButton = props => {
  const theme = useTheme();
  const { t: translate } = useTranslation();
  const { tooltip, disabled, firstIcon, text } = props;
  const isArabic = translate.language === 'ar';

  return (
    <Tooltip title={tooltip} arrow={true}>
      <Box>
        <Button
          sx={
            disabled
              ? { pointerEvents: 'none' }
              : {
                  '& .css-1gnd1fd-MuiButton-endIcon': {
                    marginLeft: theme.spacing(0),
                    marginRight: theme.spacing(1),
                    alignItems: 'flex-start',
                  },
                }
          }
          startIcon={isArabic ? null : firstIcon}
          endIcon={isArabic ? firstIcon : null}
          {...props}>
          {text}
        </Button>
      </Box>
    </Tooltip>
  );
};

export default ControlButton;
